export default __webpack_public_path__ + "static/media/GrayScrum.b32d9c14.png";